import React from "react";

const formatNumber = (value) => {
  if (value === null || value === undefined) return "0";
  const num = Number(value);
  if (Number.isNaN(num)) return value;
  return num.toLocaleString("es-EC");
};

const accentMap = {
  blue: { bg: "#e0ecff", fg: "#1d4ed8" },
  violet: { bg: "#ebe9ff", fg: "#6d28d9" },
  green: { bg: "#e5f8f2", fg: "#0f766e" },
  amber: { bg: "#fff4e0", fg: "#c2410c" },
  aqua: { bg: "#e0f7ff", fg: "#0ea5e9" },
  coral: { bg: "#ffe7e2", fg: "#dc2626" },
};

export default function SecurityTab({ seguridad = {} }) {
  const kpis = seguridad.kpis || [];
  const recentAccess = seguridad.recentAccess || [];
  const alerts = seguridad.alerts || [];

  return (
    <>
      <div className="row g-3 admin-kpi-row">
        {kpis.map((kpi) => (
          <div className="col-12 col-sm-6 col-lg-3" key={kpi.label}>
            <div className="admin-kpi-card h-100">
              <div className="admin-kpi-body">
                <span
                  className="admin-kpi-icon"
                  style={{
                    backgroundColor: accentMap[kpi.accent]?.bg || "#e5e7eb",
                    color: accentMap[kpi.accent]?.fg || "#0f172a",
                  }}
                >
                  <i className={`bi ${kpi.icon || "bi-shield-check"} me-0`} />
                </span>
                <div className="admin-kpi-text">
                  <p className="admin-kpi-label mb-0">{kpi.label}</p>
                  <div className="admin-kpi-value">{formatNumber(kpi.value)}</div>
                  <div className="admin-kpi-helper">{kpi.helper}</div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="row g-3 mt-2">
        <div className="col-12 col-xl-6">
          <div className="card admin-section-card h-100">
            <div className="card-header bg-white border-0 d-flex justify-content-between align-items-center">
              <div>
                <h6 className="mb-0">Ultimos Accesos</h6>
                <small className="text-muted">Sesiones validas (max. 5)</small>
              </div>
              <span className="dashboard-chip">
                <i className="bi bi-people me-1" />
                {recentAccess.length}
              </span>
            </div>
            <div className="table-responsive">
              <table className="table align-middle mb-0">
                <thead>
                  <tr>
                    <th>Usuario</th>
                    <th>Rol/Centro</th>
                    <th>Estado</th>
                    <th>Fecha</th>
                  </tr>
                </thead>
                <tbody>
                  {recentAccess.length ? (
                    recentAccess.map((r, idx) => (
                      <tr key={`${r.user}-${idx}`}>
                        <td>{r.user}</td>
                        <td>{r.rol}</td>
                        <td>
                          <span className={`badge rounded-pill ${r.estado === "Activo" ? "bg-success" : "bg-secondary"}`}>
                            {r.estado}
                          </span>
                        </td>
                        <td>{new Date(r.fecha).toLocaleString()}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={4} className="text-center text-muted py-3">
                        Sin accesos recientes
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="col-12 col-xl-6">
          <div className="card admin-section-card h-100">
            <div className="card-header bg-white border-0 d-flex justify-content-between align-items-center">
              <div>
                <h6 className="mb-0">Alertas de Seguridad</h6>
                <small className="text-muted">Bloqueos, resets y roles sin permisos</small>
              </div>
              <span className="dashboard-chip">
                <i className="bi bi-exclamation-triangle me-1" />
                {alerts.length}
              </span>
            </div>
            <div className="table-responsive">
              <table className="table align-middle mb-0">
                <thead>
                  <tr>
                    <th>Tipo</th>
                    <th>Usuario</th>
                    <th>Razon</th>
                  </tr>
                </thead>
                <tbody>
                  {alerts.length ? (
                    alerts.map((a, idx) => (
                      <tr key={`${a.usuario}-${idx}`}>
                        <td>{a.tipo}</td>
                        <td>{a.usuario}</td>
                        <td>{a.razon}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={3} className="text-center text-muted py-3">
                        Sin alertas activas
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

